<template>
  <Banner :property_types="property_types"></Banner>
  <div class="px-4 md:px-0">
    <div v-if="under_main_banner" class="md:w-[970px] mt-10 w-12/12 md:mx-auto">
      <a
        v-for="ad in under_main_banner"
        :key="ad.id"
        :href="resolveAdUrl(ad)"
        @click.prevent="handleAdClick(ad, routeName)"
        @mouseover="handleAdHoverStart()"
        @mouseout="handleAdHoverEnd(ad)"
      >
        <img
          :src="ad.photo"
          class="md:h-[250px] md:w-[970px] w-full md:mx-auto md:px-0"
          alt=""
        />
      </a>
    </div>
    <div class="mt-20">
      <DiscoverHome :settings="discoverHomeSettings"></DiscoverHome>
    </div>

    <ExploreHomes
      :settings="exploreHomeSettings"
      :listings="exploreHomes"
    ></ExploreHomes>
    <LatestHomes
      :settings="newlyListedHomeSettings"
      :latestHomes="latestHomes"
    ></LatestHomes>
    <div v-if="under_newly_listed" class="md:w-[728px] w-12/12 md:mx-auto">
      <a
        v-for="ad in under_newly_listed"
        :key="ad.id"
        :href="resolveAdUrl(ad)"
        @click.prevent="handleAdClick(ad, routeName)"
        @mouseover="handleAdHoverStart()"
        @mouseout="handleAdHoverEnd(ad)"
      >
        <img
          :src="ad.photo"
          class="md:h-[90px] md:w-[728px] w-full md:mx-auto px-2 mx-auto my-20 md:px-0"
          alt=""
        />
      </a>
    </div>

    <ShortStay
      :settings="shortStayHomeSettings"
      :listings="shortStay"
    ></ShortStay>
    <SuperAgents :agents="agents"></SuperAgents>
    <Newsletter></Newsletter>
    <AdBanners></AdBanners>
    <div
      v-if="before_featured_agencies"
      class="md:w-[728px] w-12/12 md:mx-auto"
    >
      <a
        v-for="ad in before_featured_agencies"
        :key="ad.id"
        :href="resolveAdUrl(ad)"
        @click.prevent="handleAdClick(ad, routeName)"
        @mouseover="handleAdHoverStart()"
        @mouseout="handleAdHoverEnd(ad)"
      >
        <img
          :src="ad.photo"
          class="md:h-[90px] md:w-[728px] w-full px-2 md:mx-auto my-20 md:px-0"
          alt=""
        />
      </a>
    </div>
    <FeaturedAgencies></FeaturedAgencies>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import FeaturedAgencies from "@/features/Home/FeaturedAgencies.vue";
import DiscoverHome from "@/features/Home/DiscoverHome.vue";
import ExploreHomes from "@/features/Home/ExploreHomes.vue";
import SuperAgents from "@/features/Home/SuperAgents.vue";
import LatestHomes from "@/features/Home/LatestHomes.vue";
import Newsletter from "@/features/Home/Newsletter.vue";
import ShortStay from "@/features/Home/ShortStay.vue";
import AdBanners from "@/features/Home/AdBanners.vue";
import Banner from "@/features/Home/Banner.vue";
import { useGetData } from "@/composables/useGetData";
import { useAds } from "@/composables/useAds";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const {
  before_featured_agencies,
  under_main_banner,
  under_newly_listed,
  handleAdClick,
  handleAdHoverStart,
  handleAdHoverEnd,
  resolveAdUrl,
  loadAds,
} = useAds();

const router = useRouter();
const store = useStore();
const base_url = store.state.baseUrl;
const settings = ref(null);
const discoverHomeSettings = ref(null);
const exploreHomeSettings = ref(null);
const newlyListedHomeSettings = ref(null);
const shortStayHomeSettings = ref(null);
const routeName = router.currentRoute.value.fullPath;
const {
  data: agents,
  // error: agentError,
  // fetchData: fetchAgentData,
} = useGetData(`${base_url}agents`);
const {
  data: exploreHomes,
  // error: exploreHomeError,
  // fetchData: fetchExploreHomeData,
} = useGetData(`${base_url}explore-homes`);
const {
  data: latestHomes,
  // error: LatestHomeError,
  // fetchData: fetchLatestHomeData,
} = useGetData(`${base_url}latest-homes`);
const {
  data: shortStay,
  // error: shortStayError,
  // fetchData: fetchShortStayData,
} = useGetData(`${base_url}properties-short-stays`);

const { data: property_types } = useGetData(
  `${base_url}property-tenure-options`
);

const loadSettings = async () => {
  await store.dispatch("fetchHomePageSettings");
  settings.value = store.state.homepage_settings.data;
  discoverHomeSettings.value = settings.value.hutloop_help || null;
  exploreHomeSettings.value = settings.value.explore_homes || null;
  newlyListedHomeSettings.value = settings.value.newly_listed || null;
  shortStayHomeSettings.value = settings.value.short_stay || null;
};

onMounted(() => {
  loadAds();
  loadSettings();
});
</script>
